/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { KTSVG } from "../../../../../_start/helpers";
import {
  failureToast,
  handlePaginate,
  PaginatedValue,
  successToast,
} from "../../../../support/utils";
import { defaultMember, IMember } from "../../models/Member";
import { actions as UserManagementActions } from "../../redux/UserManagementRedux";
import { DeleteModal } from "../../../../components/modals/DeleteModal";
import { deleteMember, getMembers } from "../../redux/UserManagementCRUD";
import { Pagination } from "../../../../components/Pagination";
import { useDebounce } from "../../../../hooks/useDebounce";
import { ActionsDropdown } from "../../../../components/ActionsDropdown";

const MembersPage = () => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [selectedMember, setSelectedMember] = useState<IMember>(defaultMember);

  const [paginatedValue, setPaginatedValue] = useState<PaginatedValue<IMember>>(
    new PaginatedValue()
  );

  const handlePaginateState = async (page_url: string) => {
    setLoading(true);
    try {
      const result = await handlePaginate<IMember>(page_url);
      setPaginatedValue(result);
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  const handleFetchList = async () => {
    setLoading(true);
    try {
      const result = await getMembers();
      setPaginatedValue(result);
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleFetchList();
  }, []);

  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce<string>(search, 750);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const result = await getMembers(search);
      setPaginatedValue(result);
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [debouncedSearch]);

  const handleDelete = async (member: IMember) => {
    setLoading(true);
    try {
      await deleteMember(member);
      successToast("Member has been deleted.");
      await dispatch(UserManagementActions.requestMembers());
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  return (
    <>
      <DeleteModal
        headerTitle="Delete Member"
        item={selectedMember}
        handleDelete={handleDelete}
      />

      <div
        className={`card card-custom card-flush ${
          loading ? "overlay overlay-block" : ""
        }`}
      >
        <div className="pt-8 card-header">
          <div className="d-flex flex-center border py-1 px-4 bg-white rounded">
            <KTSVG
              path="/media/icons/duotone/General/Search.svg"
              className="svg-icon-1 svg-icon-primary"
            />
            <input
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              type="text"
              className={`form-control border-0 fw-bold ps-2 ${
                "w-xxl-350px"
              }`}
              placeholder="Zoeken"
            />
          </div>
          <div className="card-toolbar">
            <Link className="btn btn-sm btn-light" to="/user-management/members/create">
              Create Member
            </Link>
          </div>
        </div>
        <div className={`card-body py-5 ${loading ? "overlay-wrapper" : ""}`}>
          <table className="table table-row-gray-300 gy-7">
            <thead>
              <tr className="fw-bolder fs-6 text-gray-800">
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {paginatedValue.data.map((member, idx) => (
                <tr key={idx} className="align-middle">
                  <td>{member.name}</td>
                  <td>{member.email}</td>
                  <td className="text-capitalize">{member.status ?? "-"}</td>
                  <td className="text-end">
                    {/* begin::Dropdown */}
                    <ActionsDropdown>
                      <div className="menu-item px-3">
                        <Link
                          to={`/user-management/members/${member.id}/update`}
                          className="menu-link px-3"
                        >
                          Update
                        </Link>
                      </div>
                      <div className="menu-item px-3">
                        <a
                          onClick={() => setSelectedMember(member)}
                          href="#"
                          className="menu-link px-3 text-red-500"
                          data-bs-toggle="modal"
                          data-bs-target="#custom_delete_kt_modal_1"
                        >
                          Delete
                        </a>
                      </div>
                      <div className="separator mt-3 opacity-75"></div>
                    </ActionsDropdown>
                    {/* end::Dropdown */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {loading && (
            <div className="overlay-layer rounded bg-dark bg-opacity-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
        <div className="card-footer">
          <Pagination
            loading={loading}
            pagination={paginatedValue}
            handlePaginateState={handlePaginateState}
          />
        </div>
      </div>
    </>
  );
};

export default MembersPage;
